import { useState } from 'react';
import { trU } from '../../lib/i18n';
import { C } from '../../theme/palette';
import { Inp } from './Inputs.jsx';

/**
 * Un texte facultatif d'un document (description, message en haut ou en bas)
 * replié en une petite ligne « ＋ … » tant qu'il est vide : les grandes cases
 * vides allongeaient l'écran pour rien. Rempli, ou touché, il s'ouvre comme
 * un champ ordinaire, avec son « ✨ Corriger ».
 *
 * @param {object} props propriétés passées à {@link Inp}
 * @param {string} props.label libellé du champ
 * @param {string} props.value texte
 * @returns {import('react').ReactElement} la ligne repliée ou le champ
 */
export function TexteReplie(props) {
  const [ouvert, setOuvert] = useState(false);
  if (ouvert || String(props.value || '').trim()) return <Inp {...props} />;
  return (
    <button
      type="button"
      onClick={() => setOuvert(true)}
      style={{
        display: 'block',
        width: '100%',
        textAlign: 'left',
        border: '1px dashed ' + C.border,
        borderRadius: 10,
        background: C.white,
        padding: '10px 12px',
        marginBottom: 8,
        fontSize: 10.5,
        fontWeight: 700,
        color: C.teal,
        cursor: 'pointer',
      }}
    >
      ＋ {trU(props.label)}
    </button>
  );
}
